exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gwnl-position-eval__info[data-v-5f414ce0]{padding:0 24px 40px 0}.gwnl-position-eval__info[data-v-5f414ce0]  .yxt-form-item__tooltip svg{width:100% !important}.gwnl-position-eval__info .weight-item[data-v-5f414ce0]{max-width:calc(100% - 24px);margin-right:16px}\n", ""]);

